import React from 'react';
import PropTypes from 'prop-types';
import {
  addAlphaToHex,
  colors,
  displayTrophyName,
  INBOX_MSG_TYPE,
  resolveDocumentUrl,
  TROPHY_CONFIG,
} from '../../../../../services/utilityFunctions';
import InboxMessageProp from '../../../../../sections/inbox/propTypes/inboxMessageProp';
import translate from '../../../../translate';

function NotificationExtraBlock({ t, notification }) {
  const { type, trophy, tip } = notification || {};

  switch (type) {
    case INBOX_MSG_TYPE.TROPHY: {
      let image;
      if (trophy?.type === 'custom' && trophy?.trophyCustom) {
        image = trophy.trophyCustom.icon?.url || trophy.trophyCustom.icon;
      } else if (trophy && TROPHY_CONFIG[trophy.type]) {
        image = TROPHY_CONFIG[trophy.type].imageURL;
      }

      return (
        <Wrapper>
          <img
            src={
              image?.length > 0 ? image : '/images/notifications/TrophyIcon.svg'
            }
            style={{ width: '22px', height: '22px' }}
            alt="trophy"
            className="notification-list-item-extra-block-icon"
          />
          <span className="notification-list-item-extra-block-text">
            {displayTrophyName(t, trophy)}
          </span>
        </Wrapper>
      );
    }
    case INBOX_MSG_TYPE.NEW_TIP:
      return (
        <Wrapper>
          <img
            src="/images/notifications/CoinsTipIcon.svg"
            alt="coins"
            className="notification-list-item-extra-block-icon"
          />
          <span className="notification-list-item-extra-block-text">
            {t('notifications.messages.number_coins', tip || 0)}
          </span>
        </Wrapper>
      );
    case INBOX_MSG_TYPE.WALLET_WITHDRAW_APPROVED:
      return (
        <div
          className="notification-list-item-extra-block"
          style={{ backgroundColor: colors('dynamic') }}
        >
          <a
            target="_blank"
            rel="noreferrer"
            href={resolveDocumentUrl(
              notification?.walletTransaction?.receipt?.link,
            )}
            style={{
              color: 'white',
              fontSize: '13px',
              fontWeight: '400',
              lineHeight: '22px',
            }}
          >
            {t('see.receipt')}
          </a>
        </div>
      );
    default:
      return null;
  }
}

NotificationExtraBlock.propTypes = {
  t: PropTypes.func.isRequired,
  notification: PropTypes.shape(InboxMessageProp.propTypes).isRequired,
};

export default translate(NotificationExtraBlock);

function Wrapper({ children }) {
  return (
    <div
      className="notification-list-item-extra-block"
      style={{ backgroundColor: addAlphaToHex(colors('dynamic'), 0.4) }}
    >
      {children}
    </div>
  );
}
Wrapper.propTypes = {
  children: PropTypes.node.isRequired,
};
